import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="min-h-[100dvh] grid place-items-center bg-[hsl(var(--app-bg))] text-foreground">
        <div className="font-mono text-xs text-muted-foreground">loading…</div>
      </div>
    );
  }
  if (!user) {
    // Preserve query string + hash so that flows like
    // /verify-email?token=XXX survive a redirect through /auth. AuthPage
    // restores `state.from` after a successful login.
    return <Navigate to="/auth" state={{ from: `${loc.pathname}${loc.search}${loc.hash}` }} replace />;
  }
  // Phase 22 — there is no longer an unverified-but-logged-in state. The
  // login endpoint refuses to issue a session for unverified accounts, and
  // registration lands the user on /verify-email directly via its own
  // navigation. So the `email_verified === false` gate here would never
  // fire in normal operation, and removing it kills the only code path
  // that could ever loop a verified user back to /verify-email.
  return children;
}
